<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card">
      <div class="close cursor-pointer" @click="close"><i class="fal fa-times"></i></div>
      <header class="header">
        <h2>Welcome to Make: Projects!</h2>
      </header>
      <section class="section">
        <p>Take a 1 minute tutorial to get to know your way around the site.</p>
        <div class="start-button-container">
          <button @click="startTutorial" class="start-button">Start Tutorial</button>
        </div>
      </section>
      <footer class="footer">
        <button class="skip-button" @click="close">Skip</button>
      </footer>
    </aside>
  </div>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'

import componentState from '@/mixins/component-state'
import debounce from 'lodash/debounce'

export default {
  name: 'onboardingModal',
  components: {
    ModalCustom
  },
  data: function () {
    return {
      active: false
    }
  },
  mixins: [componentState],
  watch: {
    active: function (activate) {
      activate ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    }
  },
  methods: {
    showModal: function () {
      this.active = true
    },
    startTutorial: debounce(function () {
      this.closeWithoutRoute()
      this.$router.push({ name: 'home', query: { r: this.refreshKey() } })
      this.$tours.onboarding.start()
    }),
    close: debounce(function () {
      if (this.$route.name === 'blankPage') {
        const path = '/start/template'
        this.$router.push({ path, query: this.$route.query })
      }
      this.active = false
      this.$emit('modalDone', true, true)
    }),
    closeWithoutRoute: function () {
      this.active = false
      this.$emit('modalDone', true, true)
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $onboardingcolorcolor: #00ADEE;
  $modal-body-color: #F2F2F2;
  $border-color: #DCDCDC;
  $close-icon-color: #1A051D;

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    @include mobile {
      max-width: 98vw;
    }
    // HEADER
    .header {
      font-size: 1.5rem;
      font-weight: 400;
      border-bottom: 1px solid $border-color;
      h2 {
        padding: 1.3rem 0;
        @include mobile {
          font-size: 1.3rem;
        }
      }
    }
    // SECTION
    .section,
    .footer {
      width: 70%;
      max-width: 350px;
      margin: 0 auto;
      @include mobile {
        width: 100%;
      }
    }
    .section {
      padding: 2.8rem 0 1rem;
      font-size: 1rem;
    }
    .is-flex {
      flex-direction: column;
    }
    .start-button-container {
      position: relative;
      margin-top: 2.5rem;
    }
    .start-button {
      background: $onboardingcolorcolor;
      border: none;
      padding: 1.4rem 4.3rem;
      font-size: 1.1rem;
      color: white;
      cursor: pointer;
      transition: 0.2s;
      &:hover,
      &:focus {
        background: $secondary;
        transition: 0.2s;
        &::before {
          border-bottom: 8px solid $secondary;
          transition: 0.2s;
        }
      }
      &::before {
        content: '';
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid $onboardingcolorcolor;
        position: absolute;
        top: -8px;
        left: 47%;
        transition: 0.2s;
      }
      @include mobile {
        p {
          font-size: 0.8rem;
        }
      }
    }
    // FOOTER
    .footer {
      background: $modal-body-color;
      padding: 2rem 0 3.6rem;
      .skip-button {
        padding: .3rem 1.3rem;
        border: 1px solid $primary;
        color: $primary;
        cursor: pointer;
        transition: 0.2s;
        background: transparent;
        &:hover,
        &:focus {
          background: $primary;
          color: $modal-body-color;
          transition: 0.2s;
        }
      }
    }
    // CLOSE BUTTON
    .close {
      color: $close-icon-color;
      position: absolute;
      right: 1rem;
      top: 0.4rem;
      z-index: 5;
      font-size: 1.5rem;
      font-weight: 300;
    }
    .close:hover {
      color: $link-hover;
    }
  }

</style>
